import React from "react";

import PAYSO from "../assets/images/gateway/payso.png";
import CHILLPAY from "../assets/images/gateway/chillpay.png";
import CIMB from "../assets/images/gateway/cimb.png";
import SCB from "../assets/images/gateway/scb.png";
import SPARK from "../assets/images/gateway/spark.png";
import UNIQPAY from "../assets/images/gateway/uniqpay.png";
import RABBIT from "../assets/images/gateway/rabbit.png";
import RESERVEPAY from "../assets/images/gateway/reservepay.png";
import XTC from "../assets/images/gateway/xtc.png";
import PRIMERLO from "../assets/images/gateway/primerlo.png";

// Artwork per gateway. Gateways without one (manual, or anything added later)
// fall back to the initial badge below.
export const GATEWAY_LOGO = {
  chillpay: CHILLPAY,
  cimb: CIMB,
  scb: SCB,
  spark: SPARK,
  payso: PAYSO,
  uniqpay: UNIQPAY,
  rabbit: RABBIT,
  reservepay: RESERVEPAY,
  xtc: XTC,
  primerlo: PRIMERLO,
};

// Artwork drawn in white needs a dark plate behind it; everything else sits on
// white. Keyed the same way as GATEWAY_LOGO.
export const GATEWAY_LOGO_BACKGROUND = {
  reservepay: "#000000",
};

export const gateway_logo_background = (name) =>
  GATEWAY_LOGO_BACKGROUND[name] || "#ffffff";

// `on_dark` switches the fallback badge to the palette used on the gold headers.
const GatewayLogo = ({ name, size = 24, on_dark = false }) => {
  const src = GATEWAY_LOGO[name];
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        width={size}
        height={size}
        className="rounded-circle"
        style={{
          objectFit: "cover",
          background: gateway_logo_background(name),
          flexShrink: 0,
        }}
      />
    );
  }
  return (
    <div
      className="d-flex align-items-center justify-content-center rounded-circle fw-bold"
      style={{
        width: size,
        height: size,
        fontSize: size / 2.2,
        flexShrink: 0,
        background: on_dark ? "rgba(255,255,255,0.25)" : "#f1f1f1",
        color: on_dark ? "#ffffff" : "#927530",
      }}
    >
      {(name || "?").charAt(0).toUpperCase()}
    </div>
  );
};

export default GatewayLogo;
